/*
 * @Author: lishiqiao
 * @Date: 2022-02-14 16:24:14
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-04-24 15:05:34
 */
import http from "../../../axios/index";
//  orgId 以及机构id
//  type 年Y、月M
//  year 年份（yyyy）
//  month 年月（yyyy-MM）
//  searchType 查询指标类型（1：完成情况、2：产量、3：产值、4：利润）
//  breedTypeClass 查询类型 （egg：育苗、fish：养成）
const service = {
    /**
     * @Author: lishiqiao
     * @Date: 2022-02-14 16:29:16
     * @description: 年度经营目标完成情况图表（养成、育苗）
     * @param {*} params
     */
    annalsTargetInfo(params) {
        let {
            orgId,
            type,
            year = type == 'M' ? '' : year,
            month = type == 'Y' ? '' : month,
            breedTypeClass,
            searchType
        } = params;
        return http.post('/mdtTargetAnalysisGroup/getTargetAnalysisGroupByChart', {
            orgId,
            type,
            year,
            month,
            breedTypeClass,
            searchType
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-02-14 17:31:19
     * @description: 投放概览
     * @param {*} params
     */
    putInfo(params) {
        let {
            orgId,
            type,
            year = type == 'M' ? '' : year,
            month = type == 'Y' ? '' : month,
            breedTypeClass,
            searchType
        } = params;
        return searchType == '1'
            // 投卵、苗情况图表数据（养成、育苗）
            ?
            http.post('/outSeedlingDailyGroup/getOutSeedlingDailyGroupByChart', {
                orgId,
                type,
                year,
                month,
                breedTypeClass
            })
            // 排塘情况图表数据（养成、育苗）
            :
            http.post('/mdtLossGroup/getMdtLossGroupByChart', {
                orgId,
                type,
                year,
                month,
                breedTypeClass
            })
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-02-14 17:34:20
     * @description: 实时存塘量（养成、育苗）图表
     * @param {*} params
     */
    storageInfo(params) {
        let {
            orgId,
            type,
            year = type == 'M' ? '' : year,
            month = type == 'Y' ? '' : month,
            breedTypeClass,
            searchType
        } = params;
        return searchType == '1'
            // 实时存塘量（养成、育苗）图表
            ?
            http.post('/mdtPondStockGroup/getMdtPondStockGroupByChart', {
                orgId,
                type,
                year,
                month,
                breedTypeClass
            })
            // 存塘成本（养成、育苗）图表
            :
            http.post('/midCostTotalGroup/getMidCostTotalGroupChart', {
                orgId,
                type,
                year,
                month,
                breedTypeClass
            })
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-02-14 17:38:54
     * @description: 销售概览
     * @param {*} params
     */
    salesInfo(params) {
        let {
            orgId,
            type,
            year = type == 'M' ? '' : year,
            month = type == 'Y' ? '' : month,
            breedTypeClass,
            searchType
        } = params;
        return searchType == '0' || searchType == '1'
            // 销售概览-产值、销售量（养成、育苗）图表
            ?
            http.post('/outSaleDailyGroup/getOutSaleDailyGroupByChart', {
                orgId,
                type,
                year,
                month,
                searchType,
                breedTypeClass,
            })
            // 销售概览- 客户应收（养成、育苗）图表
            :
            http.post('/outMoneyReceive/getMiddleLayerOutMoneyReceiveChart', {
                orgId,
                type,
                year,
                month,
                breedTypeClass,
            })
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-02-14 17:41:19
     * @description: 单位利润计划与实际比 成本、售价、利润（养成、育苗）图表
     * @param {*} params
     */
    prefixInfo(params) {
        let {
            orgId,
            type,
            year = type == 'M' ? '' : year,
            month = type == 'Y' ? '' : month,
            breedTypeClass,
            searchType
        } = params;
        return http.post('/outFishProfitGroup/getOutFishProfitGroupByChart', {
            orgId,
            type,
            year,
            month,
            breedTypeClass,
            searchType
        })
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-02-14 17:42:39
     * @description: 成本概览（养成、育苗）图表
     * @param {*} params
     */
    costInfo(params) {
        let {
            orgId,
            type,
            year = type == 'M' ? '' : year,
            month = type == 'Y' ? '' : month,
            breedTypeClass,
        } = params;
        return http.post('/outSaleCostGroup/getOutSaleCostGroupByChart', {
            orgId,
            type,
            year,
            month,
            breedTypeClass,
        })
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-02-14 17:48:27
     * @description: 收获概览
     * @param {*} params
     */
    harvestInfo(params) {
        let {
            orgId,
            type,
            year = type == 'M' ? '' : year,
            month = type == 'Y' ? '' : month,
            breedTypeClass,
            searchType
        } = params;
        return searchType == '0'
            // 收获概览-产量（养成、育苗）图表
            ?
            http.post('/outHarvestDailyGroup/getOutHarvestDailyGroupByChart', {
                orgId,
                type,
                year,
                month,
                breedTypeClass,
            })
            // 收获概览-塘口收获情况（养成、育苗）图表
            :
            http.post('/mdtPondHarvest/getMdtPondHarvestGroupByChart', {
                orgId,
                type,
                year,
                month,
                breedTypeClass,
            })
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-02-14 17:50:30
     * @description: 指标概览 成活率、饲料系数、每公斤卵出苗量、动保金额（养成、育苗）图表
     * @param {*} params
     */
    quotaInfo(params) {
        let {
            orgId,
            type,
            year = type == 'M' ? '' : year,
            month = type == 'Y' ? '' : month,
            breedTypeClass,
            searchType
        } = params;
        return http.post('/mdtIndicatorsGroup/getMdtIndicatorsGroupByChart', {
            orgId,
            type,
            year,
            month,
            breedTypeClass,
            searchType
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-02-14 17:53:16
     * @description: 桌面图表四个指标参数（销售数量、收获产量、存塘成本、育苗利润【养成利润】）
     * @param {*} params
     */
    totalDataInfo(params) {
        let {
            orgId,
            type,
            year = type == 'M' ? '' : year,
            month = type == 'Y' ? '' : month,
            breedTypeClass
        } = params;
        return http.post('/outFishProfitGroup/getFourIndicatorsValue', {
            orgId,
            type,
            year,
            month,
            breedTypeClass,
        });
    },
}
export default service;